import {Injectable} from '@angular/core';
import {Params} from '@angular/router';
import {BreadCrumb} from '../../../shared/services/mx-title-and-breadcrumbs.service';

@Injectable({
    providedIn: 'root'
})
export class MxRecentlyUsedService {

    constructor(
    ) {
        this.loadPinned();
        this.loadRecentlyOpened();
    }

    private recentlyOpened: Array<BreadCrumb> = new Array<BreadCrumb>();
    private pins: Array<BreadCrumb> = new Array<BreadCrumb>();

    addToRecentlyOpened(breadCrumbs: Array<BreadCrumb>): void {
        if (!breadCrumbs || breadCrumbs.length === 0) {
            return;
        }
        let currentTooltip = '';
        breadCrumbs.forEach(breadcrumb => {
            if (isNaN(+breadcrumb.id)) {
                return;
            }
            currentTooltip += this.titleCase(breadcrumb.type.replace('_', ' ')) + ' ' + breadcrumb.title + '\n';
        });
        let lastElem = breadCrumbs[breadCrumbs.length - 1];
        if (lastElem.id === 'new') {
            return;
        }
        if (this.getAllRecentlyOpened().findIndex(value => value.type === lastElem.type && value.id === lastElem.id) === -1 ) {
            lastElem.tooltip = lastElem.id === 'list' ? lastElem.tooltip : currentTooltip;
            this.recentlyOpened.unshift(lastElem);
        }

        let foundLastElem = this.recentlyOpened.findIndex(value => value.type === lastElem.type && value.id === lastElem.id);
        if (foundLastElem > 0) {
            this.recentlyOpened.unshift(this.recentlyOpened.splice(foundLastElem, 1)[0]);
        }
        this.saveRecentlyOpened();
        this.savePinned();
    }

    pin(breadcrumb: BreadCrumb): void {
        let found = this.recentlyOpened.findIndex(value => value.type === breadcrumb.type && value.id === breadcrumb.id);
        if (found > -1) {
            this.pins.push(breadcrumb);
            this.recentlyOpened.splice(found, 1);
            this.saveRecentlyOpened();
            this.savePinned();
        }
    }

    updateQueryParams(id: string, type: string, queryParam: Params): void {
        let element = this.getAllRecentlyOpened().find(value => value.type === type && value.id === id);
        if (element) {
            element.queryParam = {...queryParam};
        }
    }


    isAdded(breadcrumb: BreadCrumb): boolean {
        return this.getAllRecentlyOpened().findIndex(value => value.type === breadcrumb.type && value.id === breadcrumb.id) > -1;
    }

    isPinned(breadcrumb: BreadCrumb): boolean {
        return this.pins.findIndex(value => value.type === breadcrumb.type && value.id === breadcrumb.id) > -1;
    }

    getAllRecentlyOpened(): Array<BreadCrumb> {
      return [...this.pins, ...this.recentlyOpened.slice(0, 10)];
    }

    removeFromRecentlyOpened(breadcrumb: BreadCrumb): void {
        let found = this.recentlyOpened.findIndex(value => value.type === breadcrumb.type && value.id === breadcrumb.id);
        if (found > -1) {
            this.recentlyOpened.splice(found, 1);
        } else {
            found = this.pins.findIndex(value => value.type === breadcrumb.type && value.id === breadcrumb.id);
            if (found > -1) {
                this.pins.splice(found, 1);
            }
        }
        this.saveRecentlyOpened();
        this.savePinned();
    }

    private  savePinned(): void {
        localStorage.setItem('pins', JSON.stringify(this.pins));
    }

    private loadPinned(): void {
        this.pins = JSON.parse(localStorage.getItem('pins')) ||  [];
    }


    private saveRecentlyOpened(): void {
        localStorage.setItem('recentlyOpened', JSON.stringify(this.recentlyOpened));
    }

    private loadRecentlyOpened(): void {
        this.recentlyOpened = JSON.parse(localStorage.getItem('recentlyOpened')) ||  [];
    }

    private titleCase(str: string): string {
        return (str && str.substr(0, 1).toUpperCase() + (str.substr(1).toLowerCase())) || '';
    }


    clear(): void {
        this.recentlyOpened = [];
        localStorage.removeItem('recentlyOpened');
    }
}
